import Image from '@/components/Image';
import Heading from '@/components/_atoms/Heading';
import IconCard from '@/components/_atoms/IconCard';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface IconCardsProps {
  heading?: string;
  cards: Card[];
}

interface Card {
  glyph: Glyph;
  text: ReactNode;
}

interface Glyph {
  src: string;
  alt: string;
  width: number;
  height: number;
}

const IconCards: FC<IconCardsProps> = ({ heading, cards }) => {
  return (
    <div>
      {heading ? <StyledHeading level={2}>{heading}</StyledHeading> : null}

      <Grid>
        {cards.map(({ text, glyph }, index) => (
          <IconCard key={`icon-card-${glyph.src?.replace(/\s/g, '-') ?? index}`} glyph={<Image {...glyph} />} text={text} />
        ))}
      </Grid>
    </div>
  );
};

export default IconCards;

// Styled Components

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: ${remCalc(20)};

  > div {
    width: 100%;
    height: 100%;
  }

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: ${remCalc(20)};
  }

  ${mediaBreakpointUp('desktop')} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const StyledHeading = styled(Heading)`
  text-align: center;
  margin-bottom: ${remCalc(30)};

  ${mediaBreakpointUp('desktop')} {
    margin-bottom: ${remCalc(60)};
  }
`;
